/**
 * Helper function to calculate mean across all strides.
 * Takes an object with col0, col1, col2, etc. properties where each column is an array of 101 data points.
 * Returns a single array of 101 mean values.
 */
export function calculateMeanAcrossStrides(stridesData: any): number[] {
  if (!stridesData) {
    return [];
  }

  // Get all column keys (col0, col1, col2, etc.)
  const columnKeys = Object.keys(stridesData).filter((key) => key.startsWith('col'));

  if (columnKeys.length === 0) {
    return [];
  }

  // Get the number of data points (should be 101)
  const dataPointCount = stridesData[columnKeys[0]]?.length || 0;

  if (dataPointCount === 0) {
    return [];
  }

  // Calculate mean for each data point across all strides
  const meanData: number[] = [];
  for (let i = 0; i < dataPointCount; i++) {
    let sum = 0;
    let count = 0;

    columnKeys.forEach((colKey) => {
      const value = stridesData[colKey][i];
      if (value !== undefined && value !== null) {
        sum += value;
        count++;
      }
    });

    meanData.push(count > 0 ? sum / count : 0);
  }

  return meanData;
}
